import React, { useEffect, useState } from 'react';
import axios from 'lib/axios';
import Grid from '@mui/material/Unstable_Grid2';
import Typography from '@mui/material/Typography';
import avatar1 from '../../assets/images/users/avatar-1.png';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import DatePicker from 'react-multi-date-picker';
import Calander from 'components/Calander';
import dayjs from 'dayjs';
import UpcomingList from 'components/UpcomingList';
import { Box } from '@mui/material';
import RightSideSkeleton from 'components/skeleton/RightSideSkeleton';
import { useSelector } from 'react-redux';
import { socket } from 'socket';

const Side = () => {
    const [upcoming, setUpcoming] = useState([]);
    const [meetings, setMeetings] = useState([]);
    const [requestLoaded, setRequestLoaded] = useState(false);
    const [links, setLinks] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [limit, setLimit] = useState(5);
    const [offset, setOffset] = useState(0);
    const [requestMonth, setRequestMonth] = useState(() => {
        return new Date().getMonth();
    });
    const [calendarDate, setCalendarDate] = useState(() => dayjs());
    const { meetingIsFormal, meetingIsRecorded } = useSelector((state) => state.frontMenu);

    function meetingDayLinks(items) {
        setLinks(items.map((meeting) => `${window.location.origin}/single-view/type=meeting&model_id=${meeting.meeting_id}&comment_id=0`));
        return items.map((meeting) => new Date(meeting.meeting_date).getDate());
    }
    async function fetchmeetings(date, year) {
        setMeetings([]);
        setIsLoading(true);

        await axios
            .post(`/meetings/upcoming`, {
                month: date ?? requestMonth,
                year: year ?? new Date().getFullYear(),
                is_formal: meetingIsFormal,
                is_recorded_meeting: meetingIsRecorded,
                limit: limit,
                offset: offset
            })
            .then(({ data }) => {
                if (data.success) {
                    setIsLoading(false);
                    setMeetings(() => data.meetings);
                    setRequestLoaded(true);
                }
            })
            .catch((err) => {
                setIsLoading(false);
                console.log(err);
            });
    }
    async function fetchCalanderDate(date, year, focusLatest = false) {
        const month = date ?? new Date().getMonth();
        const calendarYear = year ?? new Date().getFullYear();
        setUpcoming([]);
        setRequestLoaded(false);
        try {
            const { data } = await axios.post(`/meetings/calendar-upcoming`, {
                month,
                year: calendarYear,
                is_formal: meetingIsFormal,
                is_recorded_meeting: meetingIsRecorded,
                focus_latest: focusLatest
            });
            if (!data.success) {
                return { month, year: calendarYear };
            }
            if (focusLatest && data.latest_meeting_date) {
                const latest = dayjs(data.latest_meeting_date);
                if (latest.month() !== month || latest.year() !== calendarYear) {
                    setCalendarDate(latest);
                    return fetchCalanderDate(latest.month(), latest.year(), false);
                }
                setCalendarDate(latest);
            } else if (!focusLatest && !meetingIsRecorded) {
                setCalendarDate(dayjs(new Date(calendarYear, month, 1)));
            }
            setUpcoming(meetingDayLinks(data.meetings || []));
            setRequestLoaded(true);
            return { month, year: calendarYear };
        } catch (err) {
            setIsLoading(false);
            console.log(err);
            return { month, year: calendarYear };
        }
    }
    async function updateHeighlitedDays(setHighlightedDays, month, setIsLoading, year) {
        setIsLoading(true);
        setLinks([]);
        await axios
            .post(`/meetings/calendar-upcoming`, {
                month: month,
                year: year ?? new Date().getFullYear(),
                is_formal: meetingIsFormal,
                is_recorded_meeting: meetingIsRecorded
            })
            .then(({ data }) => {
                if (data.success) {
                    setHighlightedDays(meetingDayLinks(data.meetings));
                    setIsLoading(false);
                }
            })
            .catch((err) => console.log(err));
    }

    useEffect(() => {
        let cancelled = false;
        (async () => {
            const focused = await fetchCalanderDate(new Date().getMonth(), new Date().getFullYear(), meetingIsRecorded);
            if (cancelled || !focused) return;
            fetchmeetings(focused.month, focused.year);
        })();
        return () => {
            cancelled = true;
        };
    }, [meetingIsFormal, meetingIsRecorded]);

    useEffect(() => {
        listen_to_channel();
    }, []);
    function listen_to_channel() {
        socket.on('meeting_created', (meeting) => {
            setMeetings((prev) => [meeting, ...prev]);
        });

        socket.on('meeting_deleted', (meeting) => {
            setMeetings((prev) => {
                prev = prev
                    .filter((item) => {
                        if (item.meeting_id != meeting.meeting_id) {
                            return item;
                        }
                    })
                    .filter((element) => element !== null && element !== '' && element !== 'null');
                return prev;
            });
        });
    }
    return (
        <Grid sm={12} container sx={{ padding: '0px' }}>
            <Box
                sx={{
                    padding: '1.5rem',
                    borderRadius: '16px',
                    width: '100%',
                    height: { md: 'calc(100vh - 7.5rem)', xs: 'calc(100vh - 0.5rem)' },
                    overflowY: 'auto',
                    backgroundColor: '#ffffff',
                    border: '1px solid #e0e0e0',
                    '&::-webkit-scrollbar': {
                        width: '6px'
                    },
                    '&::-webkit-scrollbar-track': {
                        backgroundColor: '#f5f5f5',
                        borderRadius: '3px'
                    },
                    '&::-webkit-scrollbar-thumb': {
                        backgroundColor: '#c1c1c1',
                        borderRadius: '3px',
                        '&:hover': {
                            backgroundColor: '#a8a8a8'
                        }
                    }
                }}
            >
                <Grid item sm={12}>
                    <Grid container sm={12} display="flex" direction="column" spacing={3}>
                        <Grid item sm={12}>
                            {requestLoaded ? (
                                <Box
                                    sx={{
                                        backgroundColor: '#fafafa',
                                        borderRadius: '12px',
                                        padding: '1rem',
                                        border: '1px solid #f0f0f0'
                                    }}
                                >
                                    <Calander
                                        key={`${meetingIsFormal}-${meetingIsRecorded}-${calendarDate.format('YYYY-MM')}`}
                                        type="meeting"
                                        initialValue={calendarDate}
                                        upcoming={upcoming}
                                        loading={!requestLoaded}
                                        updateHeighlitedDays={updateHeighlitedDays}
                                        links={links}
                                        allowPast={meetingIsRecorded}
                                    />
                                </Box>
                            ) : (
                                <Box
                                    sx={{
                                        backgroundColor: '#fafafa',
                                        borderRadius: '12px',
                                        padding: '1rem',
                                        border: '1px solid #f0f0f0',
                                        height: '300px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }}
                                >
                                    <Typography variant="body2" color="text.secondary">
                                        Loading calendar...
                                    </Typography>
                                </Box>
                            )}
                        </Grid>
                    </Grid>
                </Grid>
                <Box sx={{ marginTop: '1rem' }}>
                    {isLoading && (
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                            {new Array(5).fill('loading').map((_, index) => (
                                <RightSideSkeleton key={index} />
                            ))}
                        </Box>
                    )}
                    <UpcomingList list={meetings} model={'meeting'} setOffset={setOffset} />
                </Box>
            </Box>
        </Grid>
    );
};
export default Side;
